import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {Observable} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-teacher-game-setup-overlay-footer',
  templateUrl: './teacher-game-setup-overlay-footer.component.html',
  styleUrls: ['./teacher-game-setup-overlay-footer.component.scss']
})
export class TeacherGameSetupOverlayFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('totalSteps') totalSteps = 0;
  @Input('step') set setStep(val: number) {
    this.currentStep = val;
  }

  @Input('isResetFooter') isResetFooter = false;

  @Input('prevCallback') prevCallback?: () => void;
  @Input('nextCallback') nextCallback?: () => void;
  @Input('resetCallback') resetCallback?: () => void;
  @Input('stopCallback') stopCallback?: () => void;
  @Input('prevLabel') prevLabel = "Zurück";
  @Input('nextLabel') nextLabel = "Weiter";
  @Input('selectUpdateListener') set selectUpdateListener(val: Observable<number[]>) {
    val.pipe(untilDestroyed(this)).subscribe((val) => {
      this.selectTotalNumber = val.length;
    })
  }

  selectTotalNumber = 0;
  currentStep = 0;

  onResetClicked() {
    if(this.resetCallback) {
      this.resetCallback();
    }
  }

  onPrevStepClicked() {
    if(this.prevCallback) {
      this.prevCallback();
    }
  }

  onNextStepClicked() {
    if(this.nextCallback) {
      this.nextCallback();
    }
  }

  onStopClicked() {
    if(this.stopCallback) {
      this.stopCallback();
    }
  }
}
